import React from 'react';
import { useTranslation } from '../../../../i18n';
import SingleBarChart from '../../../../components/SingleBarChart';

interface GeneralQualitiesProps {
    engagementScore: number;
    userRole: 'candidate' | 'recruiter';
}

const SummaryOrganizationEngagement = (props: GeneralQualitiesProps) => {
    const { engagementScore, userRole } = props;
    const { t } = useTranslation();

    const roundScore = (number: number) => {
        return Math.trunc(number);
    };

    return (
        <>
            <SingleBarChart
                title={t('SUMMARY_PAGE.CULTURE_FIT.COMPANY_ENGAGEMENT_TITLE')}
                titleTag="h2"
                value={roundScore(engagementScore)}
                max={100}
                minLabel={t(
                    'CULTURAL_FIT.ENGAGEMENT_RESULT.BAR_CHART.COMPANY_ENGAGEMENT_BAR_MIN_LABEL',
                )}
                midLabel={t(
                    'CULTURAL_FIT.ENGAGEMENT_RESULT.BAR_CHART.COMPANY_ENGAGEMENT_BAR_MID_LABEL',
                )}
                maxLabel={t(
                    'CULTURAL_FIT.ENGAGEMENT_RESULT.BAR_CHART.COMPANY_ENGAGEMENT_BAR_MAX_LABEL',
                )}
                hasScoreValue={userRole === 'recruiter'}
                hasScoreLabel={true}
                hasUserIcon={false}
                hasScoreCheckpoints={true}
                resultLabels={{
                    low: t('GENERAL_SINGLE_BAR_CHART.RESULT_LABEL.LOW'),
                    mid: t('GENERAL_SINGLE_BAR_CHART.RESULT_LABEL.MID'),
                    high: t('GENERAL_SINGLE_BAR_CHART.RESULT_LABEL.HIGH'),
                }}
            />
        </>
    );
};

export default SummaryOrganizationEngagement;
